import { defineStore } from 'pinia';
import { useApi } from '@/lib/api';
import { useGlobalStore } from '@/store/global-store-base';

export const usePermissions = defineStore('permissions', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.permission_ListPermissions,
    dto: 'PermissionDto',
    create: api.permission_AddPermission,
    update: api.permission_UpdatePermission,
    delete: api.permission_DeletePermission,
    signalR: 'PermissionUpdate',
  });

  return {
    ...globalStoreBase,
  };
});
